import { takeEvery, select, take, put, call } from 'redux-saga/effects';
import { replace, LOCATION_CHANGE } from 'react-router-redux';
import { combineReducers } from 'redux';
import { isAuthenticated, SIGNUP, ACTIVATE_USER, AUTH_LEVEL_CHECK } from './auth';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';
import { SAVE_RESPONSES } from './assessments';
import { SAVE_QUESTIONS } from './demographic';
import { COUNSELOR_VIEW, APP_INITIALIZED } from './app';


const CHECK_REQUEST = 'intake/CHECK_REQUEST';
const CHANGE_CHECK = 'intake/CHANGE_CHECK';
const SKIP_INTAKE = 'intake/SKIP_INTAKE';

export const changeCheckAction = payload => ({
    type: CHANGE_CHECK,
    payload,
});

export const skipIntakeAction = () => ({
    type: SKIP_INTAKE,
});

const checkedStatus = (state = false, action) => {
    if (action.type === actionKey.success(CHECK_REQUEST)) {
        return true;
    }
    return state;
};

const intakeAssessments = (state = {}, action) => {
    switch (action.type) {
        case CHANGE_CHECK:
        case actionKey.success(CHECK_REQUEST):
            return action.payload;
        case actionKey.success(SAVE_RESPONSES):
            if (action.assessment === 'purpose') {
                return {
                    ...state,
                    purpose: true,
                };
            }
            return state;
        case actionKey.success(SAVE_QUESTIONS):
            return {
                ...state,
                demographic: true,
            };
        case SKIP_INTAKE:
            return {
                demographic: true,
                purpose: true,
            };
        default:
            return state;
    }
};

const skipStatus = (state = false, action) => {
    switch (action.type) {
        case SKIP_INTAKE:
            return true;
        default:
            return state;
    }
};

export default combineReducers({
    assessments: intakeAssessments,
    skip: skipStatus,
    checked: checkedStatus,
});

export function* rootSaga() {
    yield [
        takeEvery(APP_INITIALIZED, startCheckAssessment),
        takeEvery(SKIP_INTAKE, redirectHome),
        takeEvery(actionKey.success(SIGNUP), markCheckOnSignup),
        takeEvery(actionKey.success(ACTIVATE_USER), markCheckOnActivate),
    ];
}


function* startCheckAssessment() {
    yield checkAssessment();
    yield takeEvery(LOCATION_CHANGE, checkAssessment);
}


function* checkAssessment() {
    const {
        theme,
        intake,
        auth,
        app,
        router: {
            location,
        },
    } = yield select();
    if (auth.level < 5 && app.view === COUNSELOR_VIEW) {
        return;
    }
    if (location.pathname !== '/' &&
        location.pathname !== '/journey' &&
        location.pathname.indexOf('/results') !== 0 &&
        location.pathname.indexOf('/assessment') !== 0) {
        return;
    }
    if (intake.skip) {
        return;
    }
    const purposeCompleted = !theme.purposeSurvey || intake.assessments.purpose;
    const demographicCompleted = !theme.demographicQuestions || intake.assessments.demographic;

    if (purposeCompleted && demographicCompleted) {
        return;
    }
    if (intake.checked) {
        // can redirect automaticly without waiting for check
        yield redirect();
        return;
    }
    const result = yield call(request, {
        url: '/api/intake/check',
        type: CHECK_REQUEST,
    });

    if (!result || result.error) {
        // not sure how to handle this
        // so for now let's ignore this
        return;
    }
    yield redirect();
}

function* markCheckOnSignup() {
    const {
        theme,
        auth,
        app,
    } = yield select();
    if (!isAuthenticated(auth)) {
        return;
    }
    if (auth.level < 5 && app.view === COUNSELOR_VIEW) {
        return;
    }
    if (theme.purposeSurvey || theme.demographicQuestions) {
        yield put(changeCheckAction({
            demographic: !theme.demographicQuestions,
            purpose: !theme.purposeSurvey,
        }));
        yield redirect();
    }
}

function* markCheckOnActivate() {
    yield take(actionKey.success(AUTH_LEVEL_CHECK));
    const {
        theme,
        auth,
        app,
    } = yield select();
    if (auth.level < 5 && app.view === COUNSELOR_VIEW) {
        return;
    }
    if (theme.purposeSurvey || theme.demographicQuestions) {
        yield put(changeCheckAction({
            demographic: !theme.demographicQuestions,
            purpose: !theme.purposeSurvey,
        }));
        yield take(LOCATION_CHANGE);
        yield redirect();
    }
}


function* redirect() {
    const {
        intake: {
            skip,
            assessments,
        },
        router: { location },
        theme,
    } = yield select();
    if (location.pathname !== '/' &&
        location.pathname !== '/journey' &&
        location.pathname.indexOf('/results') !== 0 &&
        location.pathname.indexOf('/assessment') !== 0) {
        return;
    }
    const onWelcome = location.pathname === '/welcome';
    const purposeCompleted = !theme.purposeSurvey || assessments.purpose;
    const demographicCompleted = !theme.demographicQuestions || assessments.demographic;
    const bothCompleted = purposeCompleted && demographicCompleted;
    if (!bothCompleted && !onWelcome && !skip) {
        yield put(replace('/welcome'));
    }
}

function* redirectHome() {
    yield put(replace('/'));
}



// WEBPACK FOOTER //
// ./src/client/redux/intake.js